import React from 'react';
import UMD_GIS from '../../assets/logos/UMD_Geog.png'
import CGIS from '../../assets/logos/cgis.png';
import NLT from '../../assets/logos/nltlogopng2012.png';
import styles from './sponsors.module.css';

export default function Sponsors(): JSX.Element {
    return (
        <div id="support" className="w-full mt-24 text-center">
            <h1 className='text-2xl font-bold select-none'>With support from</h1>
            <div>
                <div className={styles.logos}>
                    <img src={UMD_GIS} alt="UMD Department of Geographical Sciences" className='p-6 md:p-0 mx-auto mt-3 cursor-pointer' onClick={() => window.open("https://geog.umd.edu/", "_blank")} />
                    <img src={CGIS} alt="Center for Geospatial Information Science" className='p-6 md:p-0 mx-auto mt-3 cursor-pointer' style={{height: '120px'}} onClick={() => window.open("https://cgis.umd.edu", "_blank")} />
                    <img src={NLT} alt="New Light Technologies" className='p-6 md:p-0 mx-auto mt-3 cursor-pointer' onClick={() => window.open("https://newlighttechnologies.com", "_blank")} />
                </div>
            </div>
        </div>
    )
}